module.exports = __webpack_public_path__ + "static/media/ico_calendar_o.20475f0a.svg";